<template>
  <main class="l-main">
    <div class="l-error c-card">
      <div class="l-error__inner-red">
        <div class="l-error__message l-error__message--red">
          <span
            ><Icon name="alert" color="#CC0621" width="31" height="28"
          /></span>
          <p>
            セッションタイムアウトになりました。
            <br />
            お手数ですが、再度ログインしてください。
          </p>
        </div>

        <div class="l-error__btn">
          <div class="c-buttonWrap4">
            <ButtonLink @click.native="goLogin()" style-type="primary" color="color2">
              ログインしてトップへ
            </ButtonLink>
            <br />
            <CButton @click.native="goTop()" style-type="primary" color="color2">
              ログインせずにトップへ
            </CButton>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: [],
  methods: {
    goTop() {
      window.location.href = process.env.VUE_APP_TOP_DOMAIN
    },
    goLogin() {
      this.setCurrentHref(process.env.VUE_APP_TOP_DOMAIN)
      window.location.href = `${process.env.VUE_APP_API_URL}/v1/stay/login`
    }
  },
  mounted() {
    this.$meta.setDocumentTitle("セッションタイムアウトになりました。");
    this.$page.isBreadcrumb = false;
    this.$page.isPageHeader = false;
    this.$page.isPageTop = false;
    this.$page.isSubHeader = true;
    this.$page.showFooterMenu = false;
  },
  watch: {
    $route() {
      this.$meta.setDocumentTitle("セッションタイムアウトになりました。");
      this.$page.isBreadcrumb = false;
      this.$page.isPageHeader = false;
      this.$page.isPageTop = false;
      this.$page.isSubHeader = true;
      this.$page.showFooterMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./l-error.scss";
@import "./l-main.scss";
</style>
